import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

// Material components
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/icons/Input';
import withTheme from '@material-ui/core/styles/withTheme';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';

import MenuIcon from '@material-ui/icons/Menu';

// Actions
import { updateLayout, toggleSidenav, toggleNotifications } from '../../../actions/layout.actions';
import { changeTheme, changeThemeDirection } from '../../../actions/theme.actions';
import authHandler from '../../../utilities/AuthHandler';
import AuthUserContext from '../../../utilities/AuthUserContext';

// Menu Items
import { menuItems } from '../../../config';

function setTitle(items, currentPath) {
	for (let i = 0; i < items.length; i += 1) {
		if (items[i].href && items[i].href === currentPath) {
			return items[i].title;
		}

		if (items[i].children) {
			const result = setTitle(items[i].children, currentPath);
			if (result) {
				return result;
			}
		}

		// Partial matching
		if (items[i].href && currentPath.includes(items[i].href)) return items[i].title;
	}
	return null;
}

class ContentToolbar extends React.Component {
	state = {
		layoutMenuEl: null,
		layoutMenuOpen: false,
		themeMenuEl: null,
		themeMenuOpen: false,
		isLoggedIn: true
	};

	logout = () => {
		console.log('logging out');
		if (authHandler.logout()) {
			this.setState({ isLoggedIn: false });
		}
	};

	componentDidMount() {
		console.log('Mounted toolbar');
		this.setState({ isLoggedIn: authHandler.isLoggedIn() });
	}

	render() {
		const { width, layout, location } = this.props;
		const showBurgerMenu = isWidthDown('sm', width) || !layout.sidenavOpen;

		// if (!this.state.isLoggedIn === true) {
		// 	console.log('not logged in');
		// 	return <Redirect to="/login" />;
		// }

		return (
			<AuthUserContext.Consumer>
				{(userProfile) =>
					userProfile != null && userProfile.odsAccess ? (
						<Toolbar>
							<IconButton color="inherit" aria-label="open sidenav" style={{ display: showBurgerMenu ? 'block' : 'none' }} onClick={this.props.toggleSidenav}>
								<MenuIcon />
							</IconButton>

							<Typography variant="title" color="inherit" noWrap>
								{setTitle(menuItems, location.pathname) || ''}
							</Typography>

							<span className="portal-flex" />

							<Typography variant="subheading" color="inherit" noWrap>
								ODS Version: 0.0.2
							</Typography>

							{/* <IconButton color="inherit" aria-label="logout" onClick={this.logout}>
								<Input />
							</IconButton> */}
						</Toolbar>
					) : (
						<Redirect to="/login" />
					)
				}
			</AuthUserContext.Consumer>
		);
	}
}

function mapStateToProps(state) {
	return {
		layout: {
			sidenavOpen: state.layout.sidenavOpen
		}
	};
}

ContentToolbar.propTypes = {
	width: PropTypes.string.isRequired,
	layout: PropTypes.shape({
		sidenavOpen: PropTypes.bool
	}).isRequired,
	theme: PropTypes.shape({}).isRequired,
	toggleSidenav: PropTypes.func.isRequired,
	toggleNotifications: PropTypes.func.isRequired,
	updateLayout: PropTypes.func.isRequired,
	changeTheme: PropTypes.func.isRequired,
	changeThemeDirection: PropTypes.func.isRequired,
	location: PropTypes.shape({}).isRequired
};

export default compose(
	withRouter,
	withWidth(),
	withTheme(),
	connect(
		mapStateToProps,
		{
			toggleSidenav,
			toggleNotifications,
			updateLayout,
			changeTheme,
			changeThemeDirection
		}
	)
)(ContentToolbar);



// WEBPACK FOOTER //
// ./src/layouts/components/content-toolbar/content-toolbar.component.js